module.exports = __webpack_public_path__ + "static/socage-da328-2335b4a5665600da14c92f089f641b41.jpg";